<div class="flex flex-col items-center justify-center w-full gap-2">
	<div class="w-full text-center mb-4">
		<p class="text-2xl font-bold">Did you submit?</p>
		<p class="mt-2 text-base text-gray-600">
			FCT requires you to submit the commercial form through email or fax.
		</p>
	</div>
	<div class="flex w-32 h-32">
		<img src="/assets/icons/design-system/mail.svg" />
	</div>
	<div class="flex items-center gap-2">
		<app-button
			btn="border"
			[icon]="ICON.PRINT"
			(onClick)="print()"
			[disabled]="!finishedRendering"
			[testHook]="testHooks.PrintButton"
			>Print</app-button
		>
		<app-button
			[icon]="ICON.DOWNLOAD"
			(onClick)="download()"
			[disabled]="!finishedRendering"
			[testHook]="testHooks.DownloadPdfButton"
			>Download PDF</app-button
		>
	</div>
	<div
		class="flex items-end gap-2 mt-4 px-40 pb-10 border-b-2 border-gray-300 w-fit"
	>
		<app-icon [icon]="ICON.EMAIL" class="text-sm"></app-icon>
		<p>commercialsolutions&#64;fct.ca</p>
		<app-icon
			[icon]="ICON.COPY"
			class="text-sm text-green cursor-pointer pr-2"
			(click)="copyToClipboard('commercialsolutions@fct.ca')"
			[testHook]="testHooks.CopyToClipboardIcon"
		></app-icon>
		<div class="border-l-2 border-gray-200 h-4"></div>
		<app-icon [icon]="ICON.FAX" class="text-sm pl-2"></app-icon>
		<p>1.866.566.8599</p>
		<app-icon
			[icon]="ICON.COPY"
			class="text-sm text-green cursor-pointer"
			(click)="copyToClipboard('1.866.566.8599')"
			[testHook]="testHooks.CopyToClipboardIcon1"
		></app-icon>
	</div>
	<div class="text-gray-400 text-left mt-4 flex flex-col gap-2">
		<p class="font-bold text-gray-600">Next step</p>
		<p>
			Once you receive the requested FCT policy, proceed to the next step to
			input the policy details.
		</p>
		<p>
			Information entered in the next step will help you generate all related
			documents in Closer.
		</p>
	</div>
	<!-- Hacky way of getting filled out form to print -->
	<app-matter-form-viewer-container
		class="opacity-0"
		(finishedRendering)="finishRender()"
	></app-matter-form-viewer-container>
</div>
